var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',[_c('forms-validated-input',{attrs:{"type":"text","name":"kiwili-expense-id","label":_vm.$t('components.admin.link_payout_to_kiwili_form.kiwili_expense_id_label'),"rules":{
      required: true,
    }},model:{value:(_vm.kiwiliExpenseId),callback:function ($$v) {_vm.kiwiliExpenseId=$$v},expression:"kiwiliExpenseId"}}),_c('icon-button',{attrs:{"role":"save","onclick":_vm.savePayout}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t("forms.save"))))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }